// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popups_popUp__C0i8- {
	/* display: flex;
    flex-direction: column; */
	position: fixed;
	top: 20vh;
	left: 0;
	right: 0;
	margin-left: auto;
	margin-right: auto;
	width: 400px;
	background-color: white;
	padding: 2rem;
	border-radius: 2rem;
}

.popups_fullScreenContainer__OQFhO {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(90, 90, 90, 0.5);
	z-index: 9999;
}

.popups_profileRedirect__n3IN9 {
	cursor: pointer;
	color: rgb(113, 196, 255);
}

.popups_detailModalIcon__l-hxk {
	background-color: #dfe4eb !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/popups/popups.module.css"],"names":[],"mappings":"AAAA;CACC;6BAC4B;CAC5B,eAAe;CACf,SAAS;CACT,OAAO;CACP,QAAQ;CACR,iBAAiB;CACjB,kBAAkB;CAClB,YAAY;CACZ,uBAAuB;CACvB,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,MAAM;CACN,SAAS;CACT,OAAO;CACP,QAAQ;CACR,iCAAiC;CACjC,aAAa;AACd;;AAEA;CACC,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,oCAAoC;AACrC","sourcesContent":[".popUp {\r\n\t/* display: flex;\r\n    flex-direction: column; */\r\n\tposition: fixed;\r\n\ttop: 20vh;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tmargin-left: auto;\r\n\tmargin-right: auto;\r\n\twidth: 400px;\r\n\tbackground-color: white;\r\n\tpadding: 2rem;\r\n\tborder-radius: 2rem;\r\n}\r\n\r\n.fullScreenContainer {\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tbackground: rgba(90, 90, 90, 0.5);\r\n\tz-index: 9999;\r\n}\r\n\r\n.profileRedirect {\r\n\tcursor: pointer;\r\n\tcolor: rgb(113, 196, 255);\r\n}\r\n\r\n.detailModalIcon {\r\n\tbackground-color: #dfe4eb !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popUp": `popups_popUp__C0i8-`,
	"fullScreenContainer": `popups_fullScreenContainer__OQFhO`,
	"profileRedirect": `popups_profileRedirect__n3IN9`,
	"detailModalIcon": `popups_detailModalIcon__l-hxk`
};
export default ___CSS_LOADER_EXPORT___;
